import React from 'react';
import { PaymentRequestButtonElement } from '@stripe/react-stripe-js';
import { StripeCheckoutAppleGooglePaymentProps } from './stripe-checkout-apple-google-payment.props';
import { ToastMolecule } from '../toast';
import { CheckoutPayment } from '../../../enums';
import { useStripeCheckoutAppleGooglePaymentEffect } from './stripe-checkout-apple-google-payment.effect';

export const StripeCheckoutAppleGooglePaymentMolecule = (
  props: StripeCheckoutAppleGooglePaymentProps
) => {
  const { paymentRequest, error } = useStripeCheckoutAppleGooglePaymentEffect(
    props.paymentRequestOptions
  );

  return (
    <div className="w-full mx-auto max-w-sm mt-1.5">
      {error && (
        <div className="text-waldo-tangerine text-sm font-medium mb-5">
          <ToastMolecule
            toastList={[
              {
                id: 1,
                title: CheckoutPayment.PAYMENT_FAILED,
                description: error.message as string,
                bgColor: 'bg-waldo-poppy',
                icon: 'warning',
              },
            ]}
            position="Top-Left"
            autoDelete={true}
            autoDeleteTime={8000}
          />
        </div>
      )}

      {paymentRequest && (
        <PaymentRequestButtonElement options={{ paymentRequest }} />
      )}
    </div>
  );
};
